// Google Consent Mode v2 helper
export const CONSENT_STORAGE_KEY = "auronixra_consent_v1";

export const DEFAULT_DENIED = {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    personalization_storage: "denied",
    security_storage: "granted",
};

export const ALL_GRANTED = {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

export const ALL_DENIED = { ...DEFAULT_DENIED };

function ensureGtag() {
    if (typeof window === "undefined") return null;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== "function") {
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
    }
    return window.gtag;
}

/**
 * Update Google Consent Mode state.
 * @param {Object} state Partial consent state overrides.
 */
export function updateConsent(state) {
    const gtag = ensureGtag();
    if (!gtag) return;
    const payload = { ...DEFAULT_DENIED, ...state };
    gtag("consent", "update", payload);
    window.dataLayer.push({ event: "cookie_consent_update" });
}

/**
 * Persist choice to localStorage.
 * @param {Object} preferences 
 */
export function persistConsent(preferences) {
    try {
        const payload = {
            timestamp: new Date().toISOString(),
            version: 1,
            preferences,
        };
        localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload));
    } catch (_) {
        /* localStorage unavailable */
    }
}

export function loadConsent() {
    try {
        const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.preferences) return null;
        return parsed;
    } catch (_) {
        return null;
    }
}

export function clearConsent() {
    try {
        localStorage.removeItem(CONSENT_STORAGE_KEY);
    } catch (_) {
        /* noop */
    }
}

/**
 * Convert category toggles into a Google consent state object.
 */
export function categoriesToConsent(categories) {
    const analytics = categories.analytics ? "granted" : "denied";
    const ads = categories.advertising ? "granted" : "denied";
    const personalization = categories.personalization ? "granted" : "denied";
    const functionality = categories.functionality ? "granted" : "denied";
    return {
        ad_storage: ads,
        ad_user_data: ads,
        ad_personalization: personalization,
        analytics_storage: analytics,
        functionality_storage: functionality,
        personalization_storage: personalization,
        security_storage: "granted",
    };
}

export const DEFAULT_CATEGORIES = {
    necessary: true,
    functionality: true,
    analytics: false,
    advertising: false,
    personalization: false,
};
